import { formatDate } from '@angular/common';

/**
 * Formato data+ora unificato in tutti i pannelli di controllo
 * (es. "24/06/2026 20:36"). Numerico all'europea: i pannelli hanno i testi in
 * inglese, ma le date restano in formato giorno/mese/anno. Essendo tutto
 * numerico il locale passato a formatDate non incide sul risultato.
 */
export const APP_DATETIME_FORMAT = 'dd/MM/yyyy HH:mm';

/** Formato solo data unificato (es. "24/06/2026"). */
export const APP_DATE_FORMAT = 'dd/MM/yyyy';

export class DateUtils {
  static formatDateToIsoDateTime(dateStr: string): string {
    const date = new Date(dateStr);
    return date.toISOString().split('.')[0].replace('Z', '');
  }

  /** Data+ora nel formato unificato dei pannelli (es. "24/06/2026 20:36"). */
  static formatDateTime(value: string | number | Date | null | undefined): string {
    if (!value) {
      return '';
    }
    return formatDate(value, APP_DATETIME_FORMAT, 'en-US');
  }

  /** Solo data nel formato unificato dei pannelli (es. "24/06/2026"). */
  static formatDateOnly(value: string | number | Date | null | undefined): string {
    if (!value) {
      return '';
    }
    return formatDate(value, APP_DATE_FORMAT, 'en-US');
  }

  formatDate(dateString: string): string {
    return DateUtils.formatDateTime(dateString);
  }
}
